module.exports = __webpack_public_path__ + "media/images/credit-cards-f4bc8299b8a663920defb494900e90e3.png";